import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  fr: {
    translation: {
      // Navigation
      "nav.back": "← Retour",
      "nav.home": "Accueil",
      "nav.about": "CV",
      "nav.portfolio": "Portfolio",
      "nav.project": "Projet",
      "nav.recruit": "Recrutement",
      
      // Footer
      "footer.description": "Développeur full-stack passionné, créateur d'applications web et mobiles. Je transforme vos idées en solutions digitales performantes.",
      "footer.quickLinks": "Liens rapides",
      "footer.technologies": "Technologies",
      "footer.contact": "Contact",
      "footer.location": "France",
      "footer.availability": "Disponible",
      "footer.rights": "Tous droits réservés",
      "footer.project": "Démarrer un projet",
      "footer.recruit": "Opportunités",
      "footer.legal": "Mentions légales",
      "footer.privacy": "Confidentialité",
      "footer.cgv": "CGV",
      
      // Legal Pages
      "legal.backHome": "Retour à l'accueil",
      "legal.lastUpdate": "Dernière mise à jour",
      "legal.mentions.title": "Mentions Légales",
      "legal.mentions.editor": "Éditeur du site",
      "legal.mentions.director": "Directeur de la publication",
      "legal.mentions.hosting": "Hébergement",
      "legal.mentions.intellectual": "Propriété intellectuelle",
      "legal.mentions.data": "Données personnelles",
      "legal.mentions.cookies": "Cookies",
      "legal.mentions.liability": "Limitations de responsabilité",
      "legal.mentions.links": "Liens hypertextes",
      "legal.mentions.law": "Droit applicable et juridiction",
      "legal.privacy.title": "Politique de Confidentialité",
      "legal.privacy.responsible": "Responsable du traitement",
      "legal.privacy.collected": "Données personnelles collectées",
      "legal.privacy.purpose": "Finalités du traitement",
      "legal.privacy.legal": "Base légale du traitement",
      "legal.privacy.recipients": "Destinataires des données",
      "legal.privacy.retention": "Durée de conservation",
      "legal.privacy.rights": "Vos droits",
      "legal.privacy.security": "Sécurité des données",
      "legal.privacy.transfer": "Transfert de données hors UE",
      "legal.privacy.minors": "Données des mineurs",
      "legal.privacy.modifications": "Modifications de la politique",
      "legal.privacy.contact": "Contact",
      "legal.cgv.title": "Condition générales de vente",
      
      // Home Page
      "home.hero.greeting": "Salut, moi c'est",
      "home.hero.name": "Ibra",
      "home.hero.wave": "👋",
      "home.hero.tagline": "Ton développeur pas cher d'appli mobile et de site internet",
      "home.hero.description": "Je transforme tes idées en applications concrètes. Que tu sois entrepreneur, créatif ou entreprise, je crée des solutions digitales sur mesure, sans jargon compliqué ni factures astronomiques.",
      "home.hero.status": "Disponible",
      
      "home.cta.client.icon": "💼",
      "home.cta.client.title": "J'ai un projet",
      "home.cta.client.subtitle": "Créons ensemble",
      "home.cta.entreprise.icon": "🏢",
      "home.cta.entreprise.title": "Je recrute",
      "home.cta.entreprise.subtitle": "Rejoins ton équipe",
      
      "home.coffee.button": "M'offrir un café",
      
      "home.testimonials.tag": "💬 Témoignages",
      "home.testimonials.title": "Ce que disent mes clients",
      "home.testimonials.subtitle": "Retours d'expérience de clients satisfaits",
      "home.testimonials.client1.name": "Marie D.",
      "home.testimonials.client1.role": "Fondatrice Startup E-commerce",
      "home.testimonials.client1.text": "\"Ibra a développé notre site e-commerce de A à Z. Professionnel, réactif et à l'écoute. Le résultat dépasse nos attentes ! Notre chiffre d'affaires a augmenté de 40% grâce à la nouvelle plateforme.\"",
      "home.testimonials.client1.project": "Projet: Site E-commerce",
      "home.testimonials.client2.name": "Thomas L.",
      "home.testimonials.client2.role": "CEO Tech Agency",
      "home.testimonials.client2.text": "\"Application mobile développée en React Native pour notre startup. Code propre, performances excellentes et respect des délais. Je recommande à 100% et je referai appel à ses services sans hésiter!\"",
      "home.testimonials.client2.project": "Projet: App Mobile Fitness",
      "home.testimonials.client3.name": "Sarah B.",
      "home.testimonials.client3.role": "Directrice Marketing",
      "home.testimonials.client3.text": "\"Refonte complète de notre site web avec un design moderne et responsive. Ibra a su comprendre nos besoins et proposer des solutions créatives. Le site charge super rapidement et le SEO s'est amélioré!\"",
      "home.testimonials.client3.project": "Projet: Refonte Site Web",
      "home.testimonials.satisfaction": "Satisfaction client",
      "home.testimonials.projects": "Projets livrés",
      "home.testimonials.rating": "Note moyenne",
      
      "home.about.tag": "👨‍💻 Qui suis-je ?",
      "home.about.title": "Développeur indépendant passionné",
      "home.about.p1": "Développeur full-stack depuis plusieurs années, je me suis spécialisé dans la création d'applications web et mobiles. Mon objectif ? Rendre la technologie accessible à tous, des startups aux PME, en proposant des solutions de qualité à des prix raisonnables.",
      "home.about.p2": "Je travaille en direct avec mes clients, ce qui me permet d'être réactif, flexible et à l'écoute. Chaque projet est unique, et j'adapte mes solutions à tes besoins réels, pas à un template tout fait.",
      
      "home.tech.tag": "🛠️ Ma Stack Technique",
      "home.tech.title": "Technologies modernes",
      "home.tech.web.title": "🌐 Web",
      "home.tech.web.desc": "Sites vitrines, plateformes e-commerce, applications web complexes avec React.js",
      "home.tech.mobile.title": "📱 Mobile",
      "home.tech.mobile.desc": "Applications iOS et Android natives avec React Native, une seule codebase",
      "home.tech.backend.title": "⚙️ Backend",
      "home.tech.backend.desc": "APIs robustes et scalables avec Node.js et bases de données MongoDB",
      
      "home.advantages.tag": "✨ Mes Atouts",
      "home.advantages.title": "Pourquoi travailler avec moi ?",
      "home.advantages.price.icon": "💰",
      "home.advantages.price.title": "Prix justes et transparents",
      "home.advantages.price.desc": "Des tarifs clairs, sans surprise. Qualité professionnelle accessible.",
      "home.advantages.speed.icon": "🚀",
      "home.advantages.speed.title": "Livraison rapide",
      "home.advantages.speed.desc": "Développement agile et efficace. Votre projet prend vie rapidement.",
      "home.advantages.support.icon": "🤝",
      "home.advantages.support.title": "Accompagnement personnalisé",
      "home.advantages.support.desc": "Un contact direct, une écoute attentive. Je suis là à chaque étape.",
      "home.advantages.quality.icon": "🎯",
      "home.advantages.quality.title": "Code moderne et performant",
      "home.advantages.quality.desc": "Technologies actuelles, bonnes pratiques. Applications rapides et fiables.",
      
      "home.final.title": "Prêt à démarrer ?",
      "home.final.description": "Que tu aies un projet en tête ou que tu cherches à renforcer ton équipe, je suis là pour en discuter autour d'un café (virtuel ou réel) !",
      
      "home.card.client.emoji": "💼",
      "home.card.client.title": "Tu as un projet ?",
      "home.card.client.desc": "Site web, application mobile, ou les deux ? Parlons-en et donnons vie à ton idée.",
      "home.card.client.feature1": "✓ Devis gratuit et rapide",
      "home.card.client.feature2": "✓ Premier échange sans engagement",
      "home.card.client.feature3": "✓ Paiements sécurisés en ligne",
      "home.card.client.feature4": "✓ Suivi transparent du projet",
      "home.card.client.button": "Demander un devis",
      
      "home.card.entreprise.emoji": "🏢",
      "home.card.entreprise.title": "Ton équipe recrute ?",
      "home.card.entreprise.desc": "Full-stack, mobile, ou backend : je suis ouvert à rejoindre une équipe dynamique.",
      "home.card.entreprise.feature1": "✓ Disponible en freelance ou CDI",
      "home.card.entreprise.feature2": "✓ Remote ou hybride",
      "home.card.entreprise.feature3": "✓ CV et portfolio à jour",
      "home.card.entreprise.feature4": "✓ Réponse rapide garantie",
      "home.card.entreprise.button": "Voir mon profil",
      
      "home.footer.copyright": "© 2024 Ibra - Développeur Full-Stack",
      
      // Contact Client Form
      "client.title": "Parlons de ton projet 💼",
      "client.subtitle": "Remplis ce formulaire et je te réponds sous 24h avec un devis gratuit",
      
      "client.section.info": "📋 Tes informations",
      "client.label.name": "Nom / Entreprise",
      "client.label.email": "Email",
      "client.label.phone": "Téléphone (optionnel)",
      "client.placeholder.name": "Jean Dupont ou Mon Entreprise",
      "client.placeholder.email": "ton@email.com",
      "client.placeholder.phone": "+33 6 12 34 56 78",
      
      "client.section.project": "🎯 Ton projet",
      "client.label.projectType": "Type de projet",
      "client.projectType.web": "🌐 Site Web",
      "client.projectType.mobile": "📱 Application Mobile",
      "client.projectType.both": "🚀 Web + Mobile",
      "client.projectType.other": "💡 Autre",
      
      "client.label.budget": "Budget estimé",
      "client.label.deadline": "Délai souhaité",
      "client.placeholder.budget": "Sélectionne une fourchette",
      "client.placeholder.deadline": "Sélectionne un délai",
      
      "client.budget.0-2000": "Moins de 2 000€",
      "client.budget.2000-5000": "2 000€ - 5 000€",
      "client.budget.5000-10000": "5 000€ - 10 000€",
      "client.budget.10000+": "Plus de 10 000€",
      "client.budget.flexible": "Budget flexible",
      
      "client.deadline.urgent": "⚡ Urgent (moins d'1 mois)",
      "client.deadline.1-3months": "📅 1-3 mois",
      "client.deadline.3-6months": "🗓️ 3-6 mois",
      "client.deadline.flexible": "⏰ Flexible",
      
      "client.label.description": "Décris ton projet",
      "client.placeholder.description": "Exemple : Je souhaite créer une application mobile de réservation de restaurants avec système de paiement intégré...",
      "client.charCount": "caractères",
      
      "client.button.submit": "Envoyer ma demande",
      "client.button.submitting": "Envoi en cours...",
      
      "client.success": "✅ Merci ! J'ai bien reçu ta demande. Je te réponds très vite à",
      "client.error": "❌ Une erreur s'est produite. Réessaie ou contacte-moi directement à ibra.developpeur@gmail.com",
      "client.footer": "En envoyant ce formulaire, tu acceptes d'être contacté par email ou téléphone concernant ton projet.",
      
      "client.validation.nameRequired": "Le nom est requis",
      "client.validation.emailRequired": "L'email est requis",
      "client.validation.emailInvalid": "Email invalide",
      "client.validation.phoneInvalid": "Numéro de téléphone invalide",
      "client.validation.projectTypeRequired": "Sélectionnez un type de projet",
      "client.validation.budgetRequired": "Indiquez votre budget",
      "client.validation.deadlineRequired": "Indiquez votre délai",
      "client.validation.descriptionRequired": "Décrivez votre projet",
      "client.validation.descriptionTooShort": "Décrivez votre projet en au moins 20 caractères",
      
      // Contact Entreprise Form
      "entreprise.title": "Travaillons ensemble 🏢",
      "entreprise.subtitle": "Présentez votre opportunité et je vous recontacte rapidement",
      
      "entreprise.section.company": "🏢 Votre entreprise",
      "entreprise.label.companyName": "Nom de l'entreprise",
      "entreprise.label.recruiterName": "Votre nom",
      "entreprise.label.email": "Email professionnel",
      "entreprise.label.phone": "Téléphone (optionnel)",
      "entreprise.placeholder.companyName": "Tech Startup Inc.",
      "entreprise.placeholder.recruiterName": "Marie Martin",
      "entreprise.placeholder.email": "marie@entreprise.com",
      "entreprise.placeholder.phone": "+33 1 23 45 67 89",
      
      "entreprise.section.position": "💼 Le poste",
      "entreprise.label.position": "Titre du poste",
      "entreprise.label.contractType": "Type de contrat",
      "entreprise.label.location": "Localisation",
      "entreprise.label.salary": "Rémunération",
      "entreprise.label.remote": "Modalités de travail",
      "entreprise.label.description": "Description du poste",
      
      "entreprise.placeholder.position": "Développeur Full-Stack React/Node.js",
      "entreprise.placeholder.location": "Paris, Lyon, Bordeaux...",
      "entreprise.placeholder.salary": "Sélectionner une fourchette",
      "entreprise.placeholder.description": "Décrivez les missions, les compétences requises, l'équipe, les avantages...",
      
      "entreprise.contractType.cdi": "📝 CDI",
      "entreprise.contractType.cdd": "⏱️ CDD",
      "entreprise.contractType.freelance": "💼 Freelance longue durée",
      "entreprise.contractType.stage": "🎓 Stage",
      
      "entreprise.remote.full": "🏠 100% Remote",
      "entreprise.remote.hybrid": "🔄 Hybride",
      "entreprise.remote.onsite": "🏢 Sur site",
      "entreprise.remote.flexible": "✨ Flexible",
      
      "entreprise.salary.30-40k": "30k - 40k €/an",
      "entreprise.salary.40-50k": "40k - 50k €/an",
      "entreprise.salary.50-60k": "50k - 60k €/an",
      "entreprise.salary.60k+": "60k+ €/an",
      "entreprise.salary.tjm": "TJM (pour freelance)",
      "entreprise.salary.negotiate": "À négocier",
      
      "entreprise.charCount": "caractères",
      "entreprise.button.submit": "Envoyer l'offre",
      "entreprise.button.submitting": "Envoi en cours...",
      
      "entreprise.success": "✅ Merci ! J'ai bien reçu votre offre. Je vous recontacte très vite pour échanger.",
      "entreprise.error": "❌ Une erreur s'est produite. Réessayez ou contactez-moi directement à ibra.developpeur@gmail.com",
      "entreprise.footer": "En envoyant ce formulaire, vous acceptez d'être contacté concernant cette opportunité.",
      
      "entreprise.validation.companyRequired": "Le nom de l'entreprise est requis",
      "entreprise.validation.nameRequired": "Votre nom est requis",
      "entreprise.validation.emailRequired": "L'email est requis",
      "entreprise.validation.emailInvalid": "Email invalide",
      "entreprise.validation.phoneInvalid": "Numéro de téléphone invalide",
      "entreprise.validation.positionRequired": "Le titre du poste est requis",
      "entreprise.validation.contractTypeRequired": "Sélectionnez un type de contrat",
      "entreprise.validation.remoteRequired": "Précisez les modalités de travail",
      "entreprise.validation.descriptionRequired": "Décrivez le poste",
      "entreprise.validation.descriptionTooShort": "Décrivez le poste en au moins 50 caractères",
      
      // Common
      "common.required": "*",
      
      // 404 Page
      "notfound.title": "Page introuvable",
      "notfound.description": "Désolé, la page que vous cherchez n'existe pas ou a été déplacée.",
      "notfound.home": "Retour à l'accueil",
      "notfound.contact": "Me contacter",
      "notfound.suggestions": "Pages populaires :",
      
      // Portfolio Page
      "portfolio.title": "Mes Projets",
      "portfolio.subtitle": "Découvrez quelques réalisations que j'ai développées",
      "portfolio.filter.all": "Tous",
      "portfolio.filter.web": "Web",
      "portfolio.filter.mobile": "Mobile",
      "portfolio.filter.both": "Web + Mobile",
      "portfolio.viewProject": "Voir le projet",
      "portfolio.cta.title": "Un projet en tête ?",
      "portfolio.cta.description": "Discutons de votre idée et donnons-lui vie ensemble",
      "portfolio.cta.button": "Demander un devis",
      "portfolio.cta.home": "Retour à l'accueil",
      "portfolio.underConstruction": "En construction...",
      
      // Cookies
      "cookies.title": "Cookies & Confidentialité",
      "cookies.description": "Nous utilisons des cookies pour améliorer votre expérience sur notre site. Les cookies essentiels sont nécessaires au fonctionnement du site, tandis que les cookies analytiques nous aident à comprendre comment vous utilisez notre site.",
      "cookies.necessary": "Cookies essentiels",
      "cookies.analytics": "Cookies analytiques",
      "cookies.required": "Requis",
      "cookies.optional": "Optionnel",
      "cookies.necessaryDesc": "Ces cookies sont indispensables au fonctionnement du site (authentification, préférences de langue, consentement cookies).",
      "cookies.analyticsDesc": "Ces cookies nous aident à comprendre comment vous utilisez notre site pour améliorer votre expérience (Google Analytics, statistiques de visite).",
      "cookies.showDetails": "▼ Afficher les détails",
      "cookies.hideDetails": "▲ Masquer les détails",
      "cookies.acceptAll": "Tout accepter",
      "cookies.reject": "Tout refuser",
      "cookies.footer": "Vous pouvez modifier vos préférences à tout moment.",
      
      // About/CV Page
      "about.available": "Disponible",
      "about.name": "Ibra",
      "about.role": "Développeur Full-Stack",
      "about.downloadCV": "Télécharger mon CV",
      "about.contact": "Me contacter",
      "about.bioTitle": "À propos de moi",
      "about.bio1": "Passionné par le développement web et mobile depuis plus de 8 ans, je crée des applications modernes, performantes et centrées sur l'utilisateur. Mon approche combine expertise technique et créativité pour transformer vos idées en solutions digitales concrètes.",
      "about.bio2": "Spécialisé en React et React Native, je maîtrise l'ensemble de la stack JavaScript moderne. Que ce soit pour une application mobile cross-platform, un site web responsive ou une API robuste, je m'adapte à vos besoins pour livrer un produit de qualité.",
      "about.experience": "Expérience",
      "about.education": "Formation",
      "about.skills": "Compétences",
      "about.certifications": "Certifications",
      "about.ctaTitle": "Travaillons ensemble !",
      "about.ctaDescription": "Un projet en tête ? Discutons-en autour d'un café ☕",
      "about.startProject": "Démarrer un projet",
      "about.viewPortfolio": "Voir mes projets",
      "about.tools": "Outils",

      "paymentSuccess": {
        "title": "Paiement confirmé !",
        "mainMessage": "Votre paiement a été traité avec succès. 🎉",
        "subMessage": "Un email de confirmation vient d'être envoyé à votre adresse avec tous les détails de votre commande.",
        "emailInfo": "Vérifiez votre boîte mail",
        "updatesInfo": "Vous recevrez des mises à jour régulières",
        "contactInfo": "Je reste à votre disposition",
        "button": "Parfait, merci !"
      },

       // Checkout
      "checkout.title": "Récapitulatif de paiement",
      "checkout.subtitle": "Veuillez vérifier les détails avant de procéder au paiement",
      "checkout.loading": "Chargement...",
      "checkout.error.title": "Oops !",
      "checkout.error.notFound": "Paiement introuvable",
      "checkout.error.alreadyPaid": "Ce paiement a déjà été effectué.",
      "checkout.backHome": "Retour à l'accueil",
      "checkout.details.title": "Détails du projet",
      "checkout.details.client": "Client",
      "checkout.details.project": "Projet",
      "checkout.details.description": "Description",
      "checkout.amount.total": "Montant total",
      "checkout.amount.vat": "TVA non applicable - Article 293B du CGI",
      "checkout.payment.title": "Méthode de paiement",
      "checkout.payment.secured": "Paiement sécurisé par",
      "checkout.payment.badges.ssl": "SSL",
      "checkout.payment.badges.card": "CB",
      "checkout.payment.badges.transfer": "Virement",
      "checkout.cgv.title": "Conditions générales",
      "checkout.cgv.items.secure": "Le paiement est sécurisé par Stripe",
      "checkout.cgv.items.invoice": "Vous recevrez une facture par email après le paiement",
      "checkout.cgv.items.start": "Le projet démarrera dès réception du paiement",
      "checkout.cgv.items.delay": "Délai de livraison : selon les termes convenus",
      "checkout.cgv.items.support": "Support technique inclus pendant 30 jours",
      "checkout.cgv.items.revisions": "Modifications incluses : 2 rounds de révisions",
      "checkout.cgv.accept": "J'accepte les",
      "checkout.cgv.link": "conditions générales de vente",
      "checkout.cgv.nonRefundable": "et je comprends que ce paiement est non remboursable une fois le projet commencé.",
      "checkout.button.pay": "Procéder au paiement sécurisé",
      "checkout.button.processing": "Redirection vers Stripe...",
      "checkout.button.accept": "Veuillez accepter les conditions générales",
      "checkout.security": "Vos informations de paiement sont entièrement sécurisées. Nous ne stockons jamais vos données bancaires.",
      "checkout.footer.question": "Une question ? Contactez-nous à",
    },

     
    },


  en: {
    translation: {
      // Navigation
      "nav.back": "← Back",
      "nav.home": "Home",
      "nav.about": "Resume",
      "nav.portfolio": "Portfolio",
      "nav.project": "Project",
      "nav.recruit": "Recruitment",
      
      // Footer
      "footer.description": "Passionate full-stack developer, creator of web and mobile applications. I transform your ideas into high-performance digital solutions.",
      "footer.quickLinks": "Quick Links",
      "footer.technologies": "Technologies",
      "footer.contact": "Contact",
      "footer.location": "France",
      "footer.availability": "Available",
      "footer.rights": "All rights reserved",
      "footer.project": "Start a project",
      "footer.recruit": "Opportunities",
      "footer.legal": "Legal Notice",
      "footer.privacy": "Privacy Policy",
      "footer.cgv": "Terms and Conditions of Sale",
      
      // Legal Pages
      "legal.backHome": "Back to home",
      "legal.lastUpdate": "Last updated",
      "legal.mentions.title": "Legal Notice",
      "legal.mentions.editor": "Website Publisher",
      "legal.mentions.director": "Publication Director",
      "legal.mentions.hosting": "Hosting",
      "legal.mentions.intellectual": "Intellectual Property",
      "legal.mentions.data": "Personal Data",
      "legal.mentions.cookies": "Cookies",
      "legal.mentions.liability": "Liability Limitations",
      "legal.mentions.links": "Hyperlinks",
      "legal.mentions.law": "Applicable Law and Jurisdiction",
      "legal.privacy.title": "Privacy Policy",
      "legal.privacy.responsible": "Data Controller",
      "legal.privacy.collected": "Personal Data Collected",
      "legal.privacy.purpose": "Processing Purposes",
      "legal.privacy.legal": "Legal Basis for Processing",
      "legal.privacy.recipients": "Data Recipients",
      "legal.privacy.retention": "Retention Period",
      "legal.privacy.rights": "Your Rights",
      "legal.privacy.security": "Data Security",
      "legal.privacy.transfer": "Data Transfer Outside EU",
      "legal.privacy.minors": "Minors Data",
      "legal.privacy.modifications": "Policy Modifications",
      "legal.privacy.contact": "Contact",
      "legal.cgv.title": "General terms and conditions",
      
      // Home Page
      "home.hero.greeting": "Hi, I'm",
      "home.hero.name": "Ibra",
      "home.hero.wave": "👋",
      "home.hero.tagline": "Your affordable developer for mobile apps and websites",
      "home.hero.description": "I turn your ideas into concrete applications. Whether you're an entrepreneur, creative, or company, I create tailor-made digital solutions, without complicated jargon or astronomical bills.",
      "home.hero.status": "Available",
      
      "home.cta.client.icon": "💼",
      "home.cta.client.title": "I have a project",
      "home.cta.client.subtitle": "Let's create together",
      "home.cta.entreprise.icon": "🏢",
      "home.cta.entreprise.title": "I'm hiring",
      "home.cta.entreprise.subtitle": "Join your team",
      
      "home.coffee.button": "Buy me a coffee",
      
      "home.testimonials.tag": "💬 Testimonials",
      "home.testimonials.title": "What my clients say",
      "home.testimonials.subtitle": "Feedback from satisfied clients",
      "home.testimonials.client1.name": "Marie D.",
      "home.testimonials.client1.role": "E-commerce Startup Founder",
      "home.testimonials.client1.text": "\"Ibra developed our e-commerce site from A to Z. Professional, responsive and attentive. The result exceeds our expectations! Our revenue increased by 40% thanks to the new platform.\"",
      "home.testimonials.client1.project": "Project: E-commerce Website",
      "home.testimonials.client2.name": "Thomas L.",
      "home.testimonials.client2.role": "CEO Tech Agency",
      "home.testimonials.client2.text": "\"Mobile app developed in React Native for our startup. Clean code, excellent performance and on-time delivery. I recommend 100% and will use his services again without hesitation!\"",
      "home.testimonials.client2.project": "Project: Fitness Mobile App",
      "home.testimonials.client3.name": "Sarah B.",
      "home.testimonials.client3.role": "Marketing Director",
      "home.testimonials.client3.text": "\"Complete redesign of our website with a modern and responsive design. Ibra understood our needs and proposed creative solutions. The site loads super fast and SEO has improved!\"",
      "home.testimonials.client3.project": "Project: Website Redesign",
      "home.testimonials.satisfaction": "Client satisfaction",
      "home.testimonials.projects": "Delivered projects",
      "home.testimonials.rating": "Average rating",
      
      "home.about.tag": "👨‍💻 About me",
      "home.about.title": "Passionate independent developer",
      "home.about.p1": "Full-stack developer for several years, I have specialized in creating web and mobile applications. My goal? Making technology accessible to everyone, from startups to SMEs, by offering quality solutions at reasonable prices.",
      "home.about.p2": "I work directly with my clients, which allows me to be responsive, flexible and attentive. Each project is unique, and I adapt my solutions to your real needs, not to a ready-made template.",
      
      "home.tech.tag": "🛠️ My Tech Stack",
      "home.tech.title": "Modern technologies",
      "home.tech.web.title": "🌐 Web",
      "home.tech.web.desc": "Showcase websites, e-commerce platforms, complex web applications with React.js",
      "home.tech.mobile.title": "📱 Mobile",
      "home.tech.mobile.desc": "Native iOS and Android applications with React Native, one codebase",
      "home.tech.backend.title": "⚙️ Backend",
      "home.tech.backend.desc": "Robust and scalable APIs with Node.js and MongoDB databases",
      
      "home.advantages.tag": "✨ My Strengths",
      "home.advantages.title": "Why work with me?",
      "home.advantages.price.icon": "💰",
      "home.advantages.price.title": "Fair and transparent pricing",
      "home.advantages.price.desc": "Clear rates, no surprises. Accessible professional quality.",
      "home.advantages.speed.icon": "🚀",
      "home.advantages.speed.title": "Fast delivery",
      "home.advantages.speed.desc": "Agile and efficient development. Your project comes to life quickly.",
      "home.advantages.support.icon": "🤝",
      "home.advantages.support.title": "Personalized support",
      "home.advantages.support.desc": "Direct contact, attentive listening. I'm here at every step.",
      "home.advantages.quality.icon": "🎯",
      "home.advantages.quality.title": "Modern and efficient code",
      "home.advantages.quality.desc": "Current technologies, best practices. Fast and reliable applications.",
      
      "home.final.title": "Ready to get started?",
      "home.final.description": "Whether you have a project in mind or are looking to strengthen your team, I'm here to discuss over coffee (virtual or real)!",
      
      "home.card.client.emoji": "💼",
      "home.card.client.title": "Have a project?",
      "home.card.client.desc": "Website, mobile app, or both? Let's talk about it and bring your idea to life.",
      "home.card.client.feature1": "✓ Free and fast quote",
      "home.card.client.feature2": "✓ First exchange without obligation",
      "home.card.client.feature3": "✓ Secure online payments",
      "home.card.client.feature4": "✓ Transparent project tracking",
      "home.card.client.button": "Request a quote",
      
      "home.card.entreprise.emoji": "🏢",
      "home.card.entreprise.title": "Hiring?",
      "home.card.entreprise.desc": "Full-stack, mobile, or backend: I'm open to joining a dynamic team.",
      "home.card.entreprise.feature1": "✓ Available as freelance or full-time",
      "home.card.entreprise.feature2": "✓ Remote or hybrid",
      "home.card.entreprise.feature3": "✓ Up-to-date CV and portfolio",
      "home.card.entreprise.feature4": "✓ Fast response guaranteed",
      "home.card.entreprise.button": "View my profile",
      
      "home.footer.copyright": "© 2024 Ibra - Full-Stack Developer",
      
      // Contact Client Form
      "client.title": "Let's talk about your project 💼",
      "client.subtitle": "Fill out this form and I'll get back to you within 24 hours with a free quote",
      
      "client.section.info": "📋 Your information",
      "client.label.name": "Name / Company",
      "client.label.email": "Email",
      "client.label.phone": "Phone (optional)",
      "client.placeholder.name": "John Doe or My Company",
      "client.placeholder.email": "your@email.com",
      "client.placeholder.phone": "+1 234 567 8900",
      
      "client.section.project": "🎯 Your project",
      "client.label.projectType": "Project type",
      "client.projectType.web": "🌐 Website",
      "client.projectType.mobile": "📱 Mobile App",
      "client.projectType.both": "🚀 Web + Mobile",
      "client.projectType.other": "💡 Other",
      
      "client.label.budget": "Estimated budget",
      "client.label.deadline": "Desired deadline",
      "client.placeholder.budget": "Select a range",
      "client.placeholder.deadline": "Select a deadline",
      
      "client.budget.0-2000": "Less than $2,500",
      "client.budget.2000-5000": "$2,500 - $6,000",
      "client.budget.5000-10000": "$6,000 - $12,000",
      "client.budget.10000+": "Over $12,000",
      "client.budget.flexible": "Flexible budget",
      
      "client.deadline.urgent": "⚡ Urgent (less than 1 month)",
      "client.deadline.1-3months": "📅 1-3 months",
      "client.deadline.3-6months": "🗓️ 3-6 months",
      "client.deadline.flexible": "⏰ Flexible",
      
      "client.label.description": "Describe your project",
      "client.placeholder.description": "Example: I want to create a mobile restaurant booking app with integrated payment system...",
      "client.charCount": "characters",
      
      "client.button.submit": "Send my request",
      "client.button.submitting": "Sending...",
      
      "client.success": "✅ Thanks! I received your request. I'll get back to you very soon at",
      "client.error": "❌ An error occurred. Try again or contact me directly at ibra.developpeur@gmail.com",
      "client.footer": "By submitting this form, you agree to be contacted by email or phone about your project.",
      
      "client.validation.nameRequired": "Name is required",
      "client.validation.emailRequired": "Email is required",
      "client.validation.emailInvalid": "Invalid email",
      "client.validation.phoneInvalid": "Invalid phone number",
      "client.validation.projectTypeRequired": "Select a project type",
      "client.validation.budgetRequired": "Indicate your budget",
      "client.validation.deadlineRequired": "Indicate your deadline",
      "client.validation.descriptionRequired": "Describe your project",
      "client.validation.descriptionTooShort": "Describe your project in at least 20 characters",
      
      // Contact Entreprise Form
      "entreprise.title": "Let's work together 🏢",
      "entreprise.subtitle": "Present your opportunity and I'll get back to you quickly",
      
      "entreprise.section.company": "🏢 Your company",
      "entreprise.label.companyName": "Company name",
      "entreprise.label.recruiterName": "Your name",
      "entreprise.label.email": "Professional email",
      "entreprise.label.phone": "Phone (optional)",
      "entreprise.placeholder.companyName": "Tech Startup Inc.",
      "entreprise.placeholder.recruiterName": "Mary Smith",
      "entreprise.placeholder.email": "mary@company.com",
      "entreprise.placeholder.phone": "+1 234 567 8900",
      
      "entreprise.section.position": "💼 The position",
      "entreprise.label.position": "Position title",
      "entreprise.label.contractType": "Contract type",
      "entreprise.label.location": "Location",
      "entreprise.label.salary": "Compensation",
      "entreprise.label.remote": "Work arrangements",
      "entreprise.label.description": "Position description",
      
      "entreprise.placeholder.position": "Full-Stack Developer React/Node.js",
      "entreprise.placeholder.location": "New York, San Francisco, Remote...",
      "entreprise.placeholder.salary": "Select a range",
      "entreprise.placeholder.description": "Describe the missions, required skills, team, benefits...",
      
      "entreprise.contractType.cdi": "📝 Full-time",
      "entreprise.contractType.cdd": "⏱️ Fixed-term",
      "entreprise.contractType.freelance": "💼 Long-term freelance",
      "entreprise.contractType.stage": "🎓 Internship",
      
      "entreprise.remote.full": "🏠 100% Remote",
      "entreprise.remote.hybrid": "🔄 Hybrid",
      "entreprise.remote.onsite": "🏢 On-site",
      "entreprise.remote.flexible": "✨ Flexible",
      
      "entreprise.salary.30-40k": "$40k - $50k/year",
      "entreprise.salary.40-50k": "$50k - $65k/year",
      "entreprise.salary.50-60k": "$65k - $80k/year",
      "entreprise.salary.60k+": "$80k+/year",
      "entreprise.salary.tjm": "Daily rate (for freelance)",
      "entreprise.salary.negotiate": "To be negotiated",
      
      "entreprise.charCount": "characters",
      "entreprise.button.submit": "Send offer",
      "entreprise.button.submitting": "Sending...",
      
      "entreprise.success": "✅ Thanks! I received your offer. I'll contact you very soon to discuss.",
      "entreprise.error": "❌ An error occurred. Try again or contact me directly at ibra.developpeur@gmail.com",
      "entreprise.footer": "By submitting this form, you agree to be contacted about this opportunity.",
      
      "entreprise.validation.companyRequired": "Company name is required",
      "entreprise.validation.nameRequired": "Your name is required",
      "entreprise.validation.emailRequired": "Email is required",
      "entreprise.validation.emailInvalid": "Invalid email",
      "entreprise.validation.phoneInvalid": "Invalid phone number",
      "entreprise.validation.positionRequired": "Position title is required",
      "entreprise.validation.contractTypeRequired": "Select a contract type",
      "entreprise.validation.remoteRequired": "Specify work arrangements",
      "entreprise.validation.descriptionRequired": "Describe the position",
      "entreprise.validation.descriptionTooShort": "Describe the position in at least 50 characters",
      
      // Common
      "common.required": "*",
      
      // 404 Page
      "notfound.title": "Page not found",
      "notfound.description": "Sorry, the page you're looking for doesn't exist or has been moved.",
      "notfound.home": "Back to home",
      "notfound.contact": "Contact me",
      "notfound.suggestions": "Popular pages:",
      
      // Portfolio Page
      "portfolio.title": "My Projects",
      "portfolio.subtitle": "Discover some projects I've developed",
      "portfolio.filter.all": "All",
      "portfolio.filter.web": "Web",
      "portfolio.filter.mobile": "Mobile",
      "portfolio.filter.both": "Web + Mobile",
      "portfolio.viewProject": "View project",
      "portfolio.cta.title": "Have a project in mind?",
      "portfolio.cta.description": "Let's discuss your idea and bring it to life together",
      "portfolio.cta.button": "Request a quote",
      "portfolio.cta.home": "Back to home",
      "portfolio.underConstruction": "Under construction...",
      
      // Cookies
      "cookies.title": "Cookies & Privacy",
      "cookies.description": "We use cookies to improve your experience on our site. Essential cookies are necessary for the site to function, while analytics cookies help us understand how you use our site.",
      "cookies.necessary": "Essential cookies",
      "cookies.analytics": "Analytics cookies",
      "cookies.required": "Required",
      "cookies.optional": "Optional",
      "cookies.necessaryDesc": "These cookies are essential for the site to function (authentication, language preferences, cookie consent).",
      "cookies.analyticsDesc": "These cookies help us understand how you use our site to improve your experience (Google Analytics, visit statistics).",
      "cookies.showDetails": "▼ Show details",
      "cookies.hideDetails": "▲ Hide details",
      "cookies.acceptAll": "Accept all",
      "cookies.reject": "Reject all",
      "cookies.footer": "You can change your preferences at any time.",
      
      // About/CV Page
      "about.available": "Available",
      "about.name": "Ibra",
      "about.role": "Full-Stack Developer",
      "about.downloadCV": "Download my CV",
      "about.contact": "Contact me",
      "about.bioTitle": "About me",
      "about.bio1": "Passionate about web and mobile development for over 8 years, I create modern, high-performance, user-centric applications. My approach combines technical expertise and creativity to transform your ideas into concrete digital solutions.",
      "about.bio2": "Specialized in React and React Native, I master the entire modern JavaScript stack. Whether for a cross-platform mobile app, a responsive website, or a robust API, I adapt to your needs to deliver a quality product.",
      "about.experience": "Experience",
      "about.education": "Education",
      "about.skills": "Skills",
      "about.certifications": "Certifications",
      "about.ctaTitle": "Let's work together!",
      "about.ctaDescription": "Have a project in mind? Let's discuss it over coffee ☕",
      "about.startProject": "Start a project",
      "about.viewPortfolio": "View my projects",
      "about.tools": "Tools",


      "paymentSuccess": {
        "title": "Payment Confirmed!",
        "mainMessage": "Your payment has been successfully processed. 🎉",
        "subMessage": "A confirmation email has been sent to your address with all the details of your order.",
        "emailInfo": "Check your mailbox",
        "updatesInfo": "You will receive regular updates",
        "contactInfo": "I remain at your disposal",
        "button": "Perfect, thank you!"
      },



    // Checkout
      "checkout.title": "Payment Summary",
      "checkout.subtitle": "Please review the details before proceeding with payment",
      "checkout.loading": "Loading...",
      "checkout.error.title": "Oops!",
      "checkout.error.notFound": "Payment not found",
      "checkout.error.alreadyPaid": "This payment has already been completed.",
      "checkout.backHome": "Back to home",
      "checkout.details.title": "Project Details",
      "checkout.details.client": "Client",
      "checkout.details.project": "Project",
      "checkout.details.description": "Description",
      "checkout.amount.total": "Total Amount",
      "checkout.amount.vat": "VAT not applicable - Article 293B CGI",
      "checkout.payment.title": "Payment Method",
      "checkout.payment.secured": "Secure payment by",
      "checkout.payment.badges.ssl": "SSL",
      "checkout.payment.badges.card": "Card",
      "checkout.payment.badges.transfer": "Transfer",
      "checkout.cgv.title": "Terms and Conditions",
      "checkout.cgv.items.secure": "Payment is secured by Stripe",
      "checkout.cgv.items.invoice": "You will receive an invoice by email after payment",
      "checkout.cgv.items.start": "The project will start upon receipt of payment",
      "checkout.cgv.items.delay": "Delivery time: according to agreed terms",
      "checkout.cgv.items.support": "Technical support included for 30 days",
      "checkout.cgv.items.revisions": "Modifications included: 2 revision rounds",
      "checkout.cgv.accept": "I accept the",
      "checkout.cgv.link": "terms of sale",
      "checkout.cgv.nonRefundable": "and I understand that this payment is non-refundable once the project has started.",
      "checkout.button.pay": "Proceed to secure payment",
      "checkout.button.processing": "Redirecting to Stripe...",
      "checkout.button.accept": "Please accept the terms and conditions",
      "checkout.security": "Your payment information is fully secured. We never store your banking data.",
      "checkout.footer.question": "Any questions? Contact us at",
    },


  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;